import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl as FormControl, UntypedFormGroup as FormGroup, Validators } from '@angular/forms';
import { MatTableDataSource as MatTableDataSource } from '@angular/material/table';
import { Visit, VisitorMember } from '../../../../tmc-visit.model';

@Component({
  selector: 'app-visit-group',
  templateUrl: './visit-group.component.html',
  styleUrls: ['./visit-group.component.scss']
})
export class VisitGroupComponent implements OnInit {

  membersTableColumns = ['hint', 'name', 'firstname', 'actions', 'filler'];
  // membersTable = new MatTableDataSource<VisitorMember>();
  membersDataSource = new MatTableDataSource();

  formGroup = new FormGroup({});

  visit: Visit;

  @Input('visit') set setVisit(value: Visit) {
    this.visit = value;
    this.setVisitMembersToTable(value.members);
  }

  constructor(
  ) {

    this.formGroup.addControl('name', new FormControl(null, [Validators.required]));
    this.formGroup.addControl('firstName', new FormControl(null, [Validators.required]));
  }

  ngOnInit(): void {
  }

  deleteMember(i: number) {
    console.log('removing by index ', i)
    console.log('members are', this.visit.members);
    this.visit.members.splice(i, 1);
    this.calculateDuplicateMarkerForMembers();
    this.setVisitMembersToTable(this.visit.members);
    console.log('members are', this.visit.members);
  }

  addMember() {

    const member = new VisitorMember();
    member.firstname = this.formGroup.value.firstName;
    member.name = this.formGroup.value.name;
    this.visit.members.push(member);

    this.calculateDuplicateMarkerForMembers();
    this.setVisitMembersToTable(this.visit.members);

    this.formGroup.patchValue({
      firstName: null,
      name: null
    });
    this.formGroup.markAsPristine();
    this.formGroup.markAsUntouched();

    console.log('members after add', this.visit);

  }

  setVisitMembersToTable(members: Array<VisitorMember>) {
    this.membersDataSource = new MatTableDataSource(members);
  }

  private calculateDuplicateMarkerForMembers() {
    for (const m of this.visit.members) {
      m.possibleDuplicate = false;
    }
    for (let i = 0; i < this.visit.members.length; i++) {
      const m = this.visit.members[i];
      for (let j = 0; j < this.visit.members.length; j++) {
        const m2 = this.visit.members[j];
        if (i !== j
          && m.name == m2.name
          && m.firstname == m2.firstname) {
          m.possibleDuplicate = true;
          m2.possibleDuplicate = true;
        }
      }
    }
  }

}
